export default __webpack_public_path__ + "static/media/Boton_4.b95678f2.png";